import StatesMap from './../components/participating_states/StatesMap.vue'
import StatesAccordions from './../components/participating_states/StatesAccordions.vue'
import { createApp } from 'vue';
import BootstrapVueNext from 'bootstrap-vue-next';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

if ( document.getElementById('states_map') ) {
    const app = createApp({
        components: {
            StatesMap
        }
    });
    app.use(BootstrapVueNext);
    app.mount('#states_map');
}

if ( document.getElementById('states_accordions') ) {
    const app = createApp({
        components: {
            StatesAccordions
        }
    });
    app.use(BootstrapVueNext);
    app.mount('#states_accordions');
}